import { createContext, useContext } from "react";

import type { CheckboxContextValue } from "./Checkbox.types";

export const CheckboxContext = createContext<CheckboxContextValue | null>(null);

export function useCheckboxContext(): CheckboxContextValue {
  const ctx = useContext(CheckboxContext);
  if (!ctx) {
    throw new Error(
      "CheckboxHeader / CheckboxContent / CheckboxChildren / CheckboxWhenChecked must be used within Checkbox or Radio",
    );
  }
  return ctx;
}
